'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// 在使用者 focus input 時，將 doc valeu 全選，方便直接輸入新值
// 放在 input state 之下，才能吃到 isDirty
// select 不需要 React re-render，故不用 provideActiveInfo，info 不需放 state
var enhancer = function enhancer(Component) {
  var SelectOnFocus = function (_React$Component) {
    _inherits(SelectOnFocus, _React$Component);

    function SelectOnFocus(props) {
      _classCallCheck(this, SelectOnFocus);

      var _this = _possibleConstructorReturn(this, (SelectOnFocus.__proto__ || Object.getPrototypeOf(SelectOnFocus)).call(this, props));

      _this.inputEl = null;
      _this.isFocused = false;

      _this.handleFocus = _this.handleFocus.bind(_this);
      _this.handleBlur = _this.handleBlur.bind(_this);
      return _this;
    }

    _createClass(SelectOnFocus, [{
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        // after get focused, something may cause re-render,
        // like special format when focused.
        // It will lost the effect of selet,
        // so select again if user are not typing
        if (!this.props.isDirty && this.isFocused) {
          this.inputEl.select();
        }
      }
    }, {
      key: 'handleFocus',
      value: function handleFocus(event) {
        this.inputEl = event.target;
        this.isFocused = true;

        this.inputEl.select();

        if (this.props.onFocus) this.props.onFocus(event);
      }
    }, {
      key: 'handleBlur',
      value: function handleBlur(event) {
        this.isFocused = false;

        if (this.props.onBlur) this.props.onBlur(event);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({}, this.props, {
          onFocus: this.handleFocus,
          onBlur: this.handleBlur
        }));
      }
    }]);

    return SelectOnFocus;
  }(_react2.default.Component);

  SelectOnFocus.propTypes = {
    onFocus: _propTypes.func,
    onBlur: _propTypes.func,
    isDirty: _propTypes.bool.isRequired
  };

  return SelectOnFocus;
};

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'selectOnFocus');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/Input/selectOnFocus.js
// module id = 1726
// module chunks = 0